import React, { FC } from "react";
import { toast } from "react-toastify";
import { useChangeInternalNumberMutation } from "../../api/projectsApi";
import Form from "../../components/Form/Form";
import { ValidatorsE } from "../../components/Form/yupValidations";
import { FormFieldT } from "../../models/models";
import { TOAST_DURATION } from "../../utils/helpers/constants";
import usePopup from "../../utils/hooks/usePopup";

import styles from "./changeInternalProjectNumber.module.scss";
import { isMobileOrTablet } from "../../utils/helpers/mediaQueries";

type ChangeInternalProjectNumberBodyPropTypes = {
  campaignId: number;
  internalNumber: string;
};

const ChangeInternalProjectNumberBody: FC<
  ChangeInternalProjectNumberBodyPropTypes
> = (props) => {
  const { campaignId, internalNumber } = props;
  const [changeInternalNumber] = useChangeInternalNumberMutation();
  const { removePopup } = usePopup();
  const fields: FormFieldT[] = [
    {
      label: "Internal project number",
      name: "number",
      defaultValue: internalNumber,
      hintText:
        "An internal project number is designed to create a link between the campaign and the project ID in your project management system. This information is private and is not displayed to anyone in the system except you.",
      validation: ValidatorsE.MAX_35,
    },
  ];

  const handleSubmit = async (data: any) => {
    const body = {
      Id: campaignId,
      PostProductionCompanyInternalNumber: data.number.toString(),
      ProjectType: "VideoAd",
    };

    try {
      const res: any = await changeInternalNumber(body);
      if (!res?.error) {
        toast("Successfully changed", {
          type: "success",
          autoClose: TOAST_DURATION,
        });
        removePopup();
        if (isMobileOrTablet()) {
          const customEvent = new CustomEvent("close-bottom-slider");
          document.dispatchEvent(customEvent);
        }
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  return (
    <Form
      onSubmit={handleSubmit}
      fields={fields}
      formID="change-internal-project-number"
      columns={1}
    />
  );
};

export default ChangeInternalProjectNumberBody;
